module.exports = __webpack_public_path__ + "static/media/google11.110d54f9.png";